import forEach from 'lodash/forEach'

export const buildURL = (pattern, options) => {
  if (!pattern) {
    return false
  }

  let url = pattern
  forEach(options, (value, key) => {
    url = url.replace(`{${key}}`, value)
  })

  // remove not provided option
  url = url.replace(/({[a-z]*})/, '')

  return url
}
